import { getPluginSelector } from 'reducers/Plugins';
import { Customer } from 'types/Customer';
import { RootState } from 'reducers';

import {
  TOGGLE_APPLY_TAF_LOGIC,
  SELECTED_ENTITY_TYPE,
  SET_GLOBAL_ENTITY_BY_TYPE,
  RESET_PRODUCT_DETAILS,
  TOOGLE_EDIT_MODE,
  SET_EDIT_STATE,
  RESET_EDIT_STATE,
  SET_PRODUCTS_STATE,
  SET_CUSTOMER_LAST_USED_ENTITIES,
  DISPLAY_PREVIOUS_ENTITIES,
  SET_FIT_ID,
} from './actionTypes';

export type entityObject = {
  entityType: string | undefined;
  entityID: string | number | undefined;
  entityName: string;
};

type tafState = {
  globalMedicalEntity: entityObject;
  globalSchoolEntity: entityObject;
  applyTafLogic: boolean;
  selectedEntityType: string;
  isEditMode: boolean;
  productsState: Record<
    string,
    {
      schoolEntity: entityObject;
      medicalEntity: entityObject;
    }
  >;
  editState: {
    selectedOrderIndex?: number;
    newEntityType?: string;
    newEntityID?: number | string | undefined;
    newEntityName?: string;
  };
  customerLastUsedEntities: Record<string, Customer[]>;
  displayPreviousEntities: boolean;
  fitID: string;
};

const tafReducer = (
  state: tafState = {
    applyTafLogic: false,
    globalSchoolEntity: {
      entityType: '',
      entityID: undefined,
      entityName: '',
    },
    globalMedicalEntity: {
      entityType: '',
      entityID: undefined,
      entityName: '',
    },
    selectedEntityType: '',
    isEditMode: false,
    productsState: {},
    editState: {
      newEntityType: '',
      newEntityID: undefined,
      newEntityName: '',
    },
    customerLastUsedEntities: {
      previousAssociations: [],
      previousProffesionals: [],
    },
    displayPreviousEntities: false,
    fitID: '',
  },
  action,
): tafState => {
  switch (action.type) {
    case TOGGLE_APPLY_TAF_LOGIC:
      return { ...state, applyTafLogic: action.payload };
    case SET_GLOBAL_ENTITY_BY_TYPE: {
      const entityData = action.payload;

      if (entityData.entityType === 'association') {
        return { ...state, globalSchoolEntity: entityData };
      }

      if (entityData.entityType === 'proffesional') {
        return { ...state, globalMedicalEntity: entityData };
      }

      return state;
    }

    case SELECTED_ENTITY_TYPE:
      return { ...state, selectedEntityType: action.payload };
    case TOOGLE_EDIT_MODE:
      return { ...state, isEditMode: action.payload };
    case SET_PRODUCTS_STATE: {
      return {
        ...state,
        productsState: action.payload,
      };
    }
    case SET_CUSTOMER_LAST_USED_ENTITIES: {
      return {
        ...state,
        customerLastUsedEntities: action.payload,
      };
    }
    case DISPLAY_PREVIOUS_ENTITIES: {
      return {
        ...state,
        displayPreviousEntities: action.payload,
      };
    }
    case SET_EDIT_STATE:
      return {
        ...state,
        editState: {
          ...state.editState,
          ...action.payload,
        },
      };
    case RESET_PRODUCT_DETAILS:
      return {
        ...state,
        productsState: {},
      };
    case RESET_EDIT_STATE:
      return {
        ...state,
        editState: {},
      };
    case SET_FIT_ID:
      return { ...state, fitID: action.payload };
    default:
      return state;
  }
};

export const getTafReduxState = (state: RootState) =>
  getPluginSelector<tafState>('taf-plugin')(n => n)(state);

export const getIsSchoolEntitySelected = (state: RootState) => {
  const tafState = getTafReduxState(state);
  const schoolID = tafState.globalSchoolEntity.entityID;
  return schoolID !== undefined && schoolID !== '';
};

export const getIsMedicalEntitySelected = (state: RootState) => {
  const tafState = getTafReduxState(state);
  const medicalID = tafState.globalMedicalEntity.entityID;
  return medicalID !== undefined && medicalID !== '';
};

export default tafReducer;
